import { useBaseViewModel } from '@/common';
import { CourseTopicEntity } from '@/domains/course-topic/entities';
import { FindCourseTopicUsecase } from '@/domains/course-topic/usecases';
import { useState } from 'react';
import { CourseTopicHttpRepository } from '../adapters/repositories';

export default function GetDetailCourseTopic() {
  const findCourseTopicUC = new FindCourseTopicUsecase(new CourseTopicHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [courseTopicData, setCourseTopicData] = useState<CourseTopicEntity>();

  const actionGetDetailCourseTopic = async (id: string) => {
    await catchAction(async () => {
      const data = await findCourseTopicUC.run(id);
      setCourseTopicData(data);
    });
  };

  return {
    loading,
    error,
    courseTopicData,
    actionGetDetailCourseTopic,
  };
}
